import type { FC, PropsWithChildren, ReactNode } from 'react';
import { Flex, Spin } from 'antd';
import styled from 'styled-components';
import { borderRadius } from '@atlas-frontend/design-tokens';
import { Padding, type PaddingProps } from '../../common/components';
import { FormLabel } from '../../common/form';
import { useInputPaddingTokens } from '../../common/form/input/useInputPaddingTokens';

export interface AlgorithmGraphReadOnlyFieldValueProps
  extends PropsWithChildren,
    PaddingProps {
  label: ReactNode;
  isLoading?: boolean;
}

export const AlgorithmGraphReadOnlyField: FC<
  AlgorithmGraphReadOnlyFieldValueProps
> = (props) => {
  const { label, isLoading = false, children, ...rest } = props;
  const [inputPaddingBlock, inputPaddingInline] = useInputPaddingTokens();
  return (
    <Flex vertical gap="small" className="nodrag">
      <FormLabel style={{ pointerEvents: 'none' }}>{label}</FormLabel>
      <StyledPadding
        vertical={inputPaddingBlock}
        horizontal={inputPaddingInline}
        {...rest}
      >
        {isLoading ? (
          <Flex gap="middle" align="center" justify="start">
            {children}
            <Spin size="small" />
          </Flex>
        ) : (
          children
        )}
      </StyledPadding>
    </Flex>
  );
};

const StyledPadding = styled(Padding)`
  background: white;
  border-radius: ${borderRadius}px;
  width: 100%;
`;
